export enum UserFields {
  name = 'name',
  email = 'email',
  role = 'role',
}
